const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "enterprise":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "enterprise",
    reducer: reducer,
};

export default data;